export default "__VITE_ASSET__BDltX7Zb__"